export const UNITS_DAYS = 'days'
export const UNITS_HOURS = 'hours'
export const UNITS_MINUTES = 'minutes'

export const DEFAULT_TIME = 24

export const DEFAULT_UNITS = UNITS_HOURS

export const BOOKING_WHEN_INVITEE_BOOKED = 'booking.when.invitee_booked'
export const BOOKING_WHEN_INVITEE_NO_SHOW = 'booking.when.invitee_no_show'
export const BOOKING_BEFORE_MEETING_STARTED = 'booking.before.meeting_started'
export const BOOKING_WHEN_MEETING_SCHEDULED = 'booking.when.meeting_scheduled'
export const BOOKING_WHEN_MEETING_STARTED = 'booking.when.meeting_started'
export const BOOKING_WHEN_MEETING_FINISHED = 'booking.when.meeting_finished'
export const BOOKING_WHEN_MEETING_CANCELED = 'booking.when.meeting_canceled'
export const BOOKING_WHEN_MEETING_RESCHEDULED = 'booking.when.meeting_rescheduled'

export const TRIGGER_TYPES = [
  BOOKING_WHEN_INVITEE_BOOKED,
  BOOKING_WHEN_MEETING_SCHEDULED,
  BOOKING_BEFORE_MEETING_STARTED,
  BOOKING_WHEN_MEETING_STARTED,
  BOOKING_WHEN_MEETING_FINISHED,
  BOOKING_WHEN_MEETING_CANCELED
]
